$('.js-swiper-reports').each(function() {
	const $container = $(this);

	const swiper = new Swiper($container, {
		freeMode: true,
		slidesPerView: 'auto',
		spaceBetween: 0,
		simulateTouch: true,
		autoHeight: true,
	});

	resizeReportsSwiper(swiper);
	$(window).resize(function () {
	   	resizeReportsSwiper(swiper);
	});

	function resizeReportsSwiper(swiper) {
		if (window.innerWidth > 1023.9) {
			$(swiper.$el).removeClass('js-attached');
			swiper.detachEvents();
		} else {
			if (!$(swiper.$el).hasClass('js-attached')) {
				$(swiper.$el).addClass('js-attached');
				swiper.attachEvents();
			}
		}
	}
});



// WEBPACK FOOTER //
// ./js/main/module/sliders/reports-swiper.js